import { render, staticRenderFns } from "./ReceiptPaymentMethods.vue?vue&type=template&id=cc786732"
import script from "./ReceiptPaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptPaymentMethods.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports